import axios from "axios";
import { Get, Post } from "../server";

// 常见问题列表
export const getQuestionList = (params: any) => {
  return Get("/admin/helpCenter/questions", params);
};

// 创建常见
export function createQuestion(data: any) {
  return axios({
    url: `/admin/helpCenter/question`,
    method: "post",
    headers: {
      "Content-Type": "application/json	",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

// 修改常见
export function updateQuestion(questionId: string, data: any) {
  return axios({
    url: `/admin/helpCenter/question/${questionId}`,
    method: "put",
    headers: {
      "Content-Type": "	application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

// 删除常见
export function deleteQuestion(questionId: string) {
  return axios({
    url: `/admin/helpCenter/question/${questionId}`,
    method: "delete",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

// 常见分类
export const getQuestionType = (params: any) => {
  return Get("/admin/helpCenter/questionCategories", params);
};

// 创建常见分类
export function createQuestionType(data: any) {
  return axios({
    url: `/admin/helpCenter/questionCategory`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

// 修改常见分类
export function updateQuestionType(categoryId: string, data: any) {
  return axios({
    url: `/admin/helpCenter/questionCategory/${categoryId}`,
    method: "put",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

// 修改常见分类
export function deleteQuestionType(categoryId: string) {
  return axios({
    url: `/admin/helpCenter/questionCategory/${categoryId}`,
    method: "delete",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}


// 获取游戏id
export function gameList(params: any) {
  return Get("/admin/game/games", params);
}

// 游戏资讯
export function gameNewlist(params: any) {
  return Get("/admin/game/gameInformationList", params)
}

// 
export function createGameNews(data: any) {
  return axios({
    url: `/admin/game/gameInformation`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}


export function uploadGamePicture(data: any) {
  return axios({
    url: `/admin/game/uploadGameInformationPicture`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

export function deleteGameList(informationId: any) {
  return axios({
    url: `/admin/game/gameInformation/${informationId}`,
    method: "delete",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

export function changeGameManegentNews(informationId: any, data: any) {
  return axios({
    url: `/admin/game/gameInformation/${informationId}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data: data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}


export function createGame(params: any) {
  return axios({
    url: `/admin/game/game`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data: params,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

export function deleteGame(gameId: any) {
  return axios({
    url: `/admin/game/game/${gameId}`,
    method: "delete",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

export function changeGame(gameId: any, data: any) {
  return axios({
    headers: {
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
      'Content-Type': 'application/json',
    },
    url: `/admin/game/game/${gameId}`,
    method: "put",
    data: data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

export function uploadGamesPicture(params: any) {
  return axios({
    headers: {
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
      'Content-Type': 'multipart/form-data',
    },
    url: `/admin/game/uploadGamePicture`,
    method: "post",
    data: params,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

// 游戏转入转出明细
export const outOrInGame = (params: any) => {
  return Get("/admin/game/gameDetails", params)
}